var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "cwb-hold-bags-report"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.isLoading,
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Bags Held by LM Hub")]), _vm._v(" "), _c('p', {
    staticClass: "page-subtitle"
  }, [_vm._v("\n        Bags at the FM parent not yet connected onward to LM destination hubs.\n      ")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("FM Parent Hub *")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.fmParentOptions,
      "selected-option": _vm.selectedFmParent,
      "placeholder": "Select FM parent hub"
    },
    on: {
      "select": _vm.onFmParentSelect
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("LM Destination Hub")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.lmHubOptions,
      "selected-option": _vm.selectedLmHub,
      "placeholder": "All LM hubs"
    },
    on: {
      "select": _vm.onLmHubSelect
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("From Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "placeholder": "From",
      "not-before": _vm.minFromDate,
      "not-after": _vm.toDate || _vm.maxToDate
    },
    on: {
      "change": _vm.onFromDateChange
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("To Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "placeholder": "To",
      "not-before": _vm.fromDate,
      "not-after": _vm.maxToDate
    },
    on: {
      "change": _vm.onToDateChange
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row action-row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSearch
    },
    on: {
      "click": _vm.searchReport
    }
  }, [_vm._v("\n              Search\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "common-info ml-2",
    attrs: {
      "type": "button",
      "disabled": !_vm.canExport || _vm.isExporting
    },
    on: {
      "click": _vm.exportCsv
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isExporting ? 'Exporting…' : 'Export CSV') + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger ml-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n              Clear\n            ")])])])])], 1), _vm._v(" "), (_vm.hasSearched) ? _c('div', {
    staticClass: "card-body1"
  }, [(_vm.selectedFmParent.text) ? _c('div', {
    staticClass: "hub-banner"
  }, [_c('span', {
    staticClass: "dot"
  }), _vm._v("\n        Parent hub: "), _c('strong', [_vm._v(_vm._s(_vm.selectedFmParent.text))]), _vm._v(" "), (_vm.reportToDate) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n          — data as of " + _vm._s(_vm.formatHoldDate(_vm.reportToDate)) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showKpiRow) ? _c('div', {
    staticClass: "kpi-row"
  }, [_c('div', {
    staticClass: "kpi-tile"
  }, [_c('p', {
    staticClass: "kpi-label"
  }, [_vm._v("Bags (seals) currently held")]), _vm._v(" "), _c('p', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.formatNum(_vm.reportData.totalBagsOnHold)))]), _vm._v(" "), _c('p', {
    staticClass: "kpi-sub"
  }, [_vm._v(_vm._s(_vm.lmFilterLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "kpi-tile"
  }, [_c('p', {
    staticClass: "kpi-label"
  }, [_vm._v("Shipments currently held")]), _vm._v(" "), _c('p', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.formatNum(_vm.reportData.totalShipmentsOnHold)))])]), _vm._v(" "), _c('div', {
    staticClass: "kpi-tile"
  }, [_c('p', {
    staticClass: "kpi-label"
  }, [_vm._v("Avg. hold age")]), _vm._v(" "), _c('p', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.formatNum(_vm.reportData.avgHoldAgeDays)) + " days")])]), _vm._v(" "), _c('div', {
    staticClass: "kpi-tile"
  }, [_c('p', {
    staticClass: "kpi-label"
  }, [_vm._v("Largest backlog")]), _vm._v(" "), _c('p', {
    staticClass: "kpi-value kpi-value-sm"
  }, [_vm._v("\n            " + _vm._s(_vm.largestBacklogLabel) + "\n          ")])])]) : _vm._e(), _vm._v(" "), _c('legend', [_vm._v("Daily detail, by LM hub — expand a row to see individual seals")]), _vm._v(" "), _c('b-card', [(!_vm.dailySummary.length) ? _c('div', {
    staticClass: "text-center text-muted py-3"
  }, [_vm._v("\n          No held bags found for selected filters.\n        ")]) : _c('table', {
    staticClass: "table table-bordered table-hover tbl summary-table"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Hold date")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("LM destination hub")]), _vm._v(" "), _c('th', [_vm._v("Bags (seals) held")]), _vm._v(" "), _c('th', [_vm._v("Shipments held")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.dailySummary), function(row, idx) {
    return [_c('tr', {
      key: 'row-' + _vm.rowKey(row),
      staticClass: "expandable-row",
      class: {
        'latest-row': idx === 0
      },
      on: {
        "click": function($event) {
          return _vm.toggleExpand(row)
        }
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('span', {
      staticClass: "chevron",
      class: {
        open: _vm.isExpanded(row)
      }
    }, [_vm._v("▸")]), _vm._v("\n                  " + _vm._s(_vm.formatHoldDate(row.holdDate)) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(row.lmDestinationHub))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNum(row.bagsHeld)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNum(row.shipmentsHeld)))])]), _vm._v(" "), (_vm.isExpanded(row)) ? _c('tr', {
      key: 'detail-' + _vm.rowKey(row),
      staticClass: "detail-row"
    }, [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "detail-wrap"
    }, [_c('p', {
      staticClass: "detail-note"
    }, [_vm._v("\n                      " + _vm._s(row.lmDestinationHub) + " — seals held since " + _vm._s(_vm.formatHoldDate(row.holdDate)) + ":\n                    ")]), _vm._v(" "), (_vm.expandLoadingKey === _vm.rowKey(row)) ? _c('div', {
      staticClass: "text-muted py-2"
    }, [_vm._v("\n                      Loading seals…\n                    ")]) : _c('div', {
      staticClass: "seal-table-panel"
    }, [_c('table', {
      staticClass: "table table-sm inner-seal-table seal-table-header"
    }, [_c('colgroup', [_c('col', {
      staticClass: "col-seal"
    }), _vm._v(" "), _c('col', {
      staticClass: "col-ship"
    }), _vm._v(" "), _c('col', {
      staticClass: "col-age"
    })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
      staticClass: "text-left"
    }, [_vm._v("Seal no.")]), _vm._v(" "), _c('th', [_vm._v("Shipments")]), _vm._v(" "), _c('th', [_vm._v("Age (days)")])])])]), _vm._v(" "), _c('div', {
      staticClass: "seal-table-scroll"
    }, [_c('table', {
      staticClass: "table table-sm inner-seal-table seal-table-body"
    }, [_c('colgroup', [_c('col', {
      staticClass: "col-seal"
    }), _vm._v(" "), _c('col', {
      staticClass: "col-ship"
    }), _vm._v(" "), _c('col', {
      staticClass: "col-age"
    })]), _vm._v(" "), _c('tbody', [(!(_vm.sealCache[_vm.rowKey(row)] || []).length) ? _c('tr', [_c('td', {
      staticClass: "text-muted text-center",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("No seals found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sealCache[_vm.rowKey(row)]), function(seal, sIdx) {
      return _c('tr', {
        key: sIdx
      }, [_c('td', {
        staticClass: "text-left seal-no"
      }, [_vm._v(_vm._s(seal.bagSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNum(seal.shipmentCount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seal.ageing))])])
    })], 2)])])])])])]) : _vm._e()]
  })], 2)])])], 1) : _vm._e()], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12e8691e","hasScoped":true}!./src/views/components/CwbHoldBagsReport/CwbHoldBagsReport.html
// module id = 1118
// module chunks = 2